<div class="k-overlay" *ngIf="newReferralDialogOpened"></div>
<kendo-window *ngIf="newReferralDialogOpened" class="kendo-window" [top]="60" [width]="850" [height]="600"
    style="min-height: 200px;" (close)="cancelConfirmationModal()" [state]="windowState">
    <kendo-window-titlebar>
        <div class="k-window-title">
            <h3 class="ellipsis-text">{{ 'NEW-REFERRAL' | translate }}</h3>
        </div>
        <button kendoWindowMaximizeAction></button>
        <button kendoWindowRestoreAction></button>
        <button kendoWindowCloseAction></button>
    </kendo-window-titlebar>
    <app-community-search [allowSelection]="false" [memberId]="memberId" [member]="member"
        [serviceCategories]="serviceCategories" [excludedServices]="excludedServices"
        [defaultResourceStatuses]="defaultResourceStatuses" [referralReassign]="referralReassign"
        (selectedServices)="onSelectedKeysChange($event)">
    </app-community-search>
    <kendo-dialog-actions style="position:absolute;margin-left:-16px" class="w-100 mt-3">
        <div style="float: left; width: 50%; text-align: left; padding-left: 1rem;">
            <div>
                <input *ngIf="!sendEmailNotificationDisabled" type="checkbox" id="sendEmailNotification"
                    [(ngModel)]="sendEmailNotification" kendoCheckBox />
                <label *ngIf="!sendEmailNotificationDisabled" class="k-checkbox-label k-text-uppercase dark"
                    for="sendEmailNotification">{{'SEND-EMAIL-NOTIFICATION' |
                    translate:patientLabel}}
                </label>
                <label class="k-form-field" *ngIf="sendEmailNotificationDisabled">
                    <i class="fas fa-exclamation-triangle icon-warn mt-2"></i>
                    <span class="k-text-uppercase icon-warn text-center warn-modal-text">
                        {{'NOTIFICATION-EMAIL-DISABLED' | translate:patientLabel}}
                    </span>
                </label>
            </div>
        </div>
        <div style="float: left; width: 50%; text-align: right; padding-right: 1rem;" class="mt-2">
            <button class="k-button" (click)="cancelConfirmationModal()">{{ 'CANCEL' | translate }}</button>
            <button class="k-button k-primary" (click)="onSendNewReferral()" [disabled]="selectedItems.length === 0">
                {{'SEND-REFERRALS' | translate }} <span
                    *ngIf="selectedItems.length > 0">({{selectedItems.length}})</span>
            </button>
        </div>
    </kendo-dialog-actions>
</kendo-window>

<!--Referral confirmation dialog-->
<kendo-dialog *ngIf="sendReferralDialogOpened" title="{{'CONFIRM-SEND-REFERRALS-MODAL-TITLE' | translate}}"
    [width]="900" (close)="sendReferralAction(false)">
    <p class="mb-2 font-weight-bold"><span translate
            [translateParams]="{organization: userOrganizationName}">{{'CONFIRM-SEND-REFERRALS-TO-PATIENT'}}</span></p>
    <div class="row">
        <div class="col-1" style="max-width:45px!important">
            <i class="fas fa-exclamation-triangle icon-warn mt-2"></i>
        </div>
        <div class="col-11 pl-0" style="line-height: 1em;">
            <span class="montserrat icon-warn text-center warn-modal-text">
                {{'REFERRAL-NOTE-INFO' | translate: patientLabel}}
            </span>
        </div>
    </div>
    <div style="max-height:380px;overflow-y:auto;overflow-x:hidden;">
        <div class="row mt-3">
            <div class="col-4 font-weight-bold">
                {{'REFERRING-TO' | translate}}
            </div>
            <div class="col-3 text-center font-weight-bold">
                {{'COMMUNITY-SERVICE-CATEGORY' | translate}}
            </div>
            <div class="col-5 pl-0 font-weight-bold">
                {{'REFERRAL-COMMENTS' | translate}}
            </div>
            <hr class="w-100" style="margin-top:2px" />
        </div>
        <div class="row mb-1" *ngFor="let program of selectedPrograms;let i = index;">
            <div class="col-4" style="margin: auto;width: 50%;">{{program.name}}&nbsp;<span
                    *ngIf="program.organization">{{ 'AT' | translate |
                    lowercase}}<span style="color:#5a85cc;">&nbsp;{{program.organization.name}}&nbsp;</span></span>
                <span class="icon-warn" *ngIf="program.referralEmail === null">*</span>
            </div>
            <div class="col-3 text-center" style="margin: auto;width: 50%;">
                <span *ngIf="program.serviceCategory">{{program.serviceCategory.name}}</span>
            </div>
            <div class="col-5 pl-0">
                <textarea kendoTextArea [autoSize]="false" class="w-100 k-textarea" rows="2"
                    [(ngModel)]="program.referralNote" maxlength="255" style="max-width:99%">
                </textarea>
            </div>
            <hr class="w-100" *ngIf="i < selectedPrograms.length-1" />
        </div>
    </div>
    <div class="row mt-3" *ngIf="missingReferralContactEmail">
        <div class="col-1" style="max-width:45px!important">
            <i class="fas fa-exclamation-triangle icon-warn"></i>
        </div>
        <div class="col-11 pl-0" style="line-height: 1em;">
            <span class="k-text-uppercase icon-warn text-center warn-modal-text">
                {{'MISSING-REFERRAL-CONTACT-EMAIL' | translate}}
            </span>
        </div>
    </div>
    <kendo-dialog-actions>
        <button kendoButton (click)="sendReferralAction(false)">{{'NO' | translate}}</button>
        <button appPreventClick kendoButton (click)="sendReferralAction(true)">{{'YES' | translate}}</button>
    </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog title="{{ 'PLEASE-CONFIRM' | translate }}" *ngIf="cancelConfirmationDialogOpened"
    (close)="cancelConfirmationAction(false)" [minWidth]="250" [width]="450">
    <p>{{ 'CANCEL-REFERRAL-SEARCH-CONFIRMATION' | translate }}</p>
    <kendo-dialog-actions>
        <button kendoButton (click)="cancelConfirmationAction(false)">{{ 'NO' | translate }}</button>
        <button appPreventClick kendoButton (click)="cancelConfirmationAction(true)" [primary]="true">{{ 'YES' |
            translate
            }}</button>
    </kendo-dialog-actions>
</kendo-dialog>